import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import { FiberManualRecord as FiberManualRecordIcon, InfoOutlined as InfoOutlinedIcon } from '@material-ui/icons';
import {
  FDStack,
} from '@facet-wealth/design';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { Tooltip } from 'Components/UI/Tooltip';


const useStyles = buildUseStyles('PaymentStatusTextMeta', (theme) => ({
  typography: {
    lineHeight: `${theme.spacing(2)}px`,
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    textTransform: 'capitalize',
  },
}));

const PaymentStatusColor = {
  paid: 'accentGreen',
  succeeded: 'accentGreen',
  success: 'accentGreen',
  draft: 'orange',
  uncollectible: 'orange',
  void: 'orange',
  open: 'orange',
  deleted: 'red',
  failed: 'red',
};

const PaymentStatusTextMeta = ({
  resource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const value = resource?.attr('status');
  const paymentFailed = resource?.isTruthy('paymentFailed');
  const color = PaymentStatusColor[value] ? PaymentStatusColor[value] : 'lightGray';

  return (
    <FDStack alignItems="flex-start" justifyContent="flex-start">
      <Icon icon={FiberManualRecordIcon} boxSize={'xxs'} fill={color} stroke={color} />
      <Typography
        className={classNames(classes.typography)}
        variant={'h6'}
        weight={'bold'}
        color={'darkGray'}
      >
        {value}
      </Typography>
      {paymentFailed ? (
        <Tooltip title={resource.attr('paymentFailedDetails')}>
          <Icon icon={InfoOutlinedIcon} boxSize={'xxs'} fill={'primaryGray'} />
        </Tooltip>
      ) : null}
    </FDStack>
  );
};

PaymentStatusTextMeta.defaultProps = {};

PaymentStatusTextMeta.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default PaymentStatusTextMeta;
